import { createContext, useContext, useState, useCallback } from 'react';
import api from '../services/api';

const ProfileContext = createContext(null);

export function ProfileProvider({ children }) {
  const [profile, setProfile] = useState(null);
  const [universities, setUniversities] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchProfile = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/profile');
      setProfile(res.data.profile);
      setUniversities(res.data.universities || []);
    } catch (err) {
      console.error('Error fetching profile:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  const saveProfile = async (data) => {
    const res = await api.put('/profile', data);
    setProfile(res.data.profile);
    return res.data.profile;
  };

  const addUniversity = async (universityName) => {
    const res = await api.post('/profile/university', { universityName });
    setUniversities(prev => [...prev.filter(u => u.university_name !== universityName), res.data.university]);
    return res.data.university;
  };

  const saveEssays = async (universityId, essays) => {
    const res = await api.put(`/profile/university/${universityId}/essays`, { essays });
    setUniversities(prev => prev.map(u => u.id === universityId ? res.data.university : u));
    return res.data.university;
  };

  const updateUniversities = (newList) => setUniversities(newList);

  return (
    <ProfileContext.Provider value={{
      profile, universities, loading, fetchProfile, saveProfile,
      addUniversity, saveEssays, updateUniversities
    }}>
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfile() {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error('useProfile must be used within ProfileProvider');
  return ctx;
}
